import React from 'react';
import { Typography, TextField, Button, Box, Link } from '@mui/material';
import { AccountCircle, MailOutline, LocationOn, Phone, PersonOutline, CreateOutlined } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

{/** TextInputField component encapsulating input field logic */}
const TextInputField = ({ label, startIcon, ...props }) => (
  <TextField
    label={label}
    fullWidth
    margin="normal"
    InputProps={{
      startAdornment: startIcon,
      sx: { color: '#fff' }
    }}
    InputLabelProps={{
      sx: { color: '#fff' }
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        '& fieldset': { borderColor: '#fff' },
        '&:hover fieldset': { borderColor: '#fff' },
        '&.Mui-focused fieldset': { borderColor: '#fff' }
      },
      '& .MuiInputLabel-root': {
        color: '#fff',
        '&.Mui-focused': { color: '#fff' }
      }
    }}
    {...props}
  />
);

{/** RegistrationForm component encapsulating the registration form */}
const RegistrationForm = () => (
  <Box
    component="form"
    sx={{
      textAlign: 'center',
      backgroundColor: '#143F6C',
      color: '#fff',
      width: '100%',
      padding: '20px',
      borderRadius: '10px',
    }}
  >
    <Typography fontWeight="bold" variant="h5" gutterBottom>
      Comienza hoy
    </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px', mb: 2 }}>
      <TextInputField
        label="Nombre"
        startIcon={<PersonOutline sx={{ color: '#fff', marginRight: 2 }} />}
      />
      <TextInputField
        label="Apellido"
        startIcon={<PersonOutline sx={{ color: '#fff', marginRight: 2 }} />}
      />
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px', mb: 2 }}>
      <TextInputField
        label="Email"
        startIcon={<MailOutline sx={{ color: '#fff', marginRight: 2 }} />}
      />
      <TextInputField
        label="País"
        startIcon={<LocationOn sx={{ color: '#fff', marginRight: 2 }} />}
      />
    </Box>
    <TextInputField
      label="Número"
      startIcon={<Phone sx={{ color: '#fff', marginRight: 2 }} />}
    />
    <Button
      variant="contained"
      color="success"
      size="large"
      startIcon={<CreateOutlined />}
      sx={{
        mt: 2,
        width: 'fit-content',
        '&:hover': { color: '#fff' }
      }}
      component={RouterLink}
      to="/tracking/mis-pedidos"
    >
      Registrarse
    </Button>
    <Typography variant="body2" align="center" mt={2}>
      ¿Ya tienes una cuenta? <Link sx={{ color: "white" }} component={RouterLink} to="/tracking/inicio-de-sesion">Iniciar sesión</Link>
    </Typography>
  </Box>
);

{/** WelcomeSection component encapsulating the welcome message */}
const WelcomeSection = () => (
  <Box sx={{ flex: 1, color: '#143F6C', padding: 2 }}>
    <Typography sx={{ fontWeight: 'bold' }} variant="h2" component="h2" gutterBottom>
      ¡Bienvenido a PILU!
    </Typography>
    <Typography variant="body1" sx={{ fontSize: '1.5rem' }} paragraph>
      Descubre la calidad y elegancia en cada prenda que creamos. En PILU, nos enorgullecemos de nuestra artesanía y atención al detalle en cada etapa del proceso de fabricación.
    </Typography>
    <Typography sx={{ mt: '60px' }} variant="h5" fontWeight="bold" gutterBottom>
      ¡Únete a nuestra comunidad de amantes de la moda hecha a mano!
    </Typography>
  </Box>
);

{/** HeroTracking component encapsulating the main hero section */}
export const HeroTracking = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      pt: '50px',
      position: 'fixed',
      top: '0',
      width: '100%',
    }}
  >
    <Box sx={{ display: 'flex', maxWidth: '90%' }}>
      <WelcomeSection />
      <Box sx={{ width: 32 }} />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: 2 }}>
        <RegistrationForm />
      </Box>
    </Box>
  </Box>
);
